function initProgressBar() {
  const bar = document.createElement('div');
  bar.id = 'ndg-pbar';
  document.body.prepend(bar);

  const update = () => {
    const total = document.documentElement.scrollHeight - window.innerHeight;
    bar.style.width = total > 0 ? (window.scrollY / total * 100) + '%' : '0';
  };
  window.addEventListener('scroll', update, { passive: true });
}

function initModeSwitcher() {
  if (typeof ndgData === 'undefined') return;

  document.querySelectorAll('[href*="switch="]').forEach(link => {
    link.addEventListener('click', async (e) => {
      const mode = new URL(link.href).searchParams.get('switch');
      if (!mode) return;
      e.preventDefault();
      try {
        const res = await fetch(ndgData.restUrl + 'ndg/v1/site-mode', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-WP-Nonce': ndgData.nonce },
          body: JSON.stringify({ mode }),
        });
        if (res.ok) window.location.reload();
      } catch {
        window.location.href = link.href;
      }
    });
  });
}

function initFilterPills() {
  document.querySelectorAll('.ndg-filter-group').forEach(group => {
    const pills = group.querySelectorAll('.ndg-pill');
    pills.forEach(pill => {
      pill.addEventListener('click', () => {
        pills.forEach(p => p.classList.remove('is-active'));
        pill.classList.add('is-active');
        const filter = pill.dataset.filter;
        document.querySelectorAll(group.dataset.target).forEach(item => {
          const matches = !filter || filter === 'all' || item.dataset.category?.includes(filter);
          item.style.display = matches ? '' : 'none';
        });
      });
    });
  });
}

function initTrailerModal() {
  document.querySelectorAll('[data-trailer-url]').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const url = trigger.dataset.trailerUrl;
      if (!url) return;

      const overlay = Object.assign(document.createElement('div'), {
        className: 'ndg-modal-overlay',
      });
      overlay.style.cssText = 'position:fixed;inset:0;z-index:9999;background:rgba(8,8,8,.95);display:flex;align-items:center;justify-content:center;backdrop-filter:blur(8px)';

      const closeBtn = Object.assign(document.createElement('button'), { textContent: '✕' });
      closeBtn.style.cssText = 'position:absolute;top:24px;right:28px;background:none;border:none;color:#f0ede6;font-size:24px;cursor:pointer';

      const iframe = document.createElement('iframe');
      iframe.src = url + '?autoplay=1';
      iframe.allow = 'autoplay; fullscreen';
      iframe.style.cssText = 'width:min(90vw,1100px);aspect-ratio:16/9;border:none;border-radius:8px';

      closeBtn.addEventListener('click', () => overlay.remove());
      overlay.addEventListener('click', ev => { if (ev.target === overlay) overlay.remove(); });
      document.addEventListener('keydown', ev => { if (ev.key === 'Escape') overlay.remove(); }, { once: true });

      overlay.append(closeBtn, iframe);
      document.body.append(overlay);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initProgressBar();
  initModeSwitcher();
  initFilterPills();
  initTrailerModal();
});
